"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.DefaultContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _Message = _interopRequireDefault(require("../../../../components/Message/Message"));

var DefaultContent = function DefaultContent() {
  return /*#__PURE__*/_react["default"].createElement(_Message["default"], {
    error: true,
    header: "Something went wrong",
    content: "Please try again and if the problem persists, contact support.",
    "data-qa": "content-error-message",
    className: "error-message"
  });
};

exports.DefaultContent = DefaultContent;